query allFootballTeams(
  $first: Int,
  $offset: Int,
  $filter: FootballTeamFilter,
  ) {
  teams: allFootballTeams(
      first: $first,
      offset: $offset,
      filter: $filter
    ) {
    nodes {
      teamMappings: footballTeamMappingsByIntId {
        nodes {
          extId
          extRef
          feed
          mappingId
          mappingType
          createdAt
          createdBy
          updatedAt
          updatedBy
        }
      }
        name
        source
        teamId
    }
    totalCount
  }
}
